// V2 HANDLING SWAPPING OUT OLD RECAPTCHA 2 FOR INVIBLE RECAPTCHA.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { RenderCheckboxRadioField, RenderTextareaField, RenderSubmitButton } from '../../common/form';
import * as Validations from '../../common/form/commonValidations';
import { sendMessage } from '../../../actions/GuestActions';
import { hideModal } from '../../../actions/ModalActions';

const isReady = () => typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';

class GuestMessageModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recaptchaReady: isReady(),
      recaptchaResponse: null,
      recaptchaCheck: null,
      recaptchaExpired: false
    };

    this.formatName = this.formatName.bind(this);
    this.recaptchaCallback = this.recaptchaCallback.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleError = this.handleError.bind(this);
    this.recaptchaCallback = this.recaptchaCallback.bind(this);
    this.onRecaptchaExpired = this.onRecaptchaExpired.bind(this);
  }

  componentDidMount() {
    this.initializeRecaptcha();
  }

  componentWillUnmount() {
    clearTimeout(this.state.recaptchaCheck);
  }

  onRecaptchaExpired() {
    this.setState({ recaptchaExpired: true });
  }

  onSubmit(values) {
    // reformat input so '' are false
    // '' happens when a guest selects 'TRUE' then deselects. Initial Value (false) is lost resulting in redux-forms sending ''.
    if (values.send_to_self === '') {
      const formattedValues = Object.assign(
        {},
        values,
        {
          guest_group_ids: values.guest_group_ids,
          message: values.message,
          send_to_self: false
        }
      );
      this.props.onSubmit2(formattedValues);
    } else {
      this.props.onSubmit2(values);
    }
  }

  getPrimaryGuest(guestGroup) {
    return _.find(guestGroup.guests, guest => guest.relationship_type === 'PRIMARY');
  }

  handleError() {
    this.setState({ error: true });
  }

  initializeRecaptcha() {
    const recaptchaCheck = setInterval(() => {
      if (this.state.recaptchaReady) {
        clearTimeout(this.state.recaptchaCheck);
        const sitekey = (window.zola.env === 'production') ? '6LeioV0UAAAAAPRmqrC2cERXl8k001P_zm7lqcKA' : '6Le-kV0UAAAAAPJLDAI2TeBQEuy0oCpRA4mZg8am';
        window.grecaptcha.render('guest-message-recaptcha',
          {
            sitekey,
            callback: this.recaptchaCallback,
            'expired-callback': this.onRecaptchaExpired
          });
      } else {
        this.setState({ recaptchaReady: isReady() });
      }
    }, 500);
    this.setState({ recaptchaCheck });
  }

  recaptchaCallback(response) {
    this.setState({ recaptchaResponse: response, recaptchaExpired: false });
  }

  formatName(guestGroup) {
    const guest = this.getPrimaryGuest(guestGroup);
    if (guest.first_name && guest.family_name) {
      return `${guest.first_name} ${guest.family_name}`;
    } else if (guest.first_name) {
      return `${guest.first_name}`;
    } else if (guest.family_name) {
      return `${guest.family_name}`;
    }
    return 'Guest';
  }

  render() {
    const { guestGroupsWithEmail, guestGroupsWithoutEmail, wedding, submitting, valid, handleSubmit, sitekey } = this.props;
    const notExpired = !this.state.recaptchaExpired;
    return (
      <div>
        <div id="guest-message-modal" className="guest-modal">
          {!this.state.recaptchaReady &&
            <Helmet>
              <script src="https://www.google.com/recaptcha/api.js?initializeRecaptcha=initializeRecaptcha&render=explicit" async defer />
            </Helmet>
          }
          <div className="modal-header ">
            <h3 className="modal-title">Send Message</h3>
          </div>
          <div className="modal-body">
            <p className="modal-body-subhead">We&apos;ll send the note below to your guests.</p>
            {guestGroupsWithoutEmail.length > 0 &&
              <p id="guest-group-message-to" className="form-control-static text-danger guest-group-need-email">
                <strong>{guestGroupsWithoutEmail.map(this.formatName).join(', ')}</strong> requires an email address to send request.
              </p>
            }
            <form onSubmit={handleSubmit(this.onSubmit)} noValidate>
              <div className="form-horizontal guest-message">
                <div className="form-group send-info" id="send-info">
                  {/* FROM */ }
                  <div className="col-xs-12 from-container">
                    <label htmlFor="guest-group-message-to" className="from control-label col-xs-10 col-sm-1">From</label>
                    <p className="form-control-static col-xs-12 col-sm-11">{wedding.owner_first_name} {wedding.owner_last_name} and {wedding.partner_first_name} {wedding.partner_last_name}</p>
                  </div>
                  {/* TO / BCC */ }
                  <div className="col-xs-12 to-bc-container">
                    <label htmlFor="guest-group-message-to" className="control-label to-bcc col-xs-10 col-sm-1">To / BCC</label>
                    <p id="guest-group-message-to" className="form-control-static col-xs-12 col-sm-11">
                      {guestGroupsWithEmail.map(this.formatName).join(', ')}
                    </p>
                  </div>
                  {/* SUBJECT */ }
                  <div className="col-xs-12 subject-container">
                    <label htmlFor="guest-group-message-subject" className=" control-label col-xs-10 subject col-sm-1">Subject</label>
                    <div className="subject-line-container col-xs-12 col-sm-11">
                      <p id="guest-group-message-subject" className="form-control-static">A Message From {wedding.owner_first_name} and {wedding.partner_first_name}</p>
                    </div>
                  </div>
                </div>
                {/* MESSAGE */ }
                <div className="message-container">
                  <label htmlFor="guest-group-message-message" className="col-sm-1 control-label message-label">Message</label>
                  <div className="textarea-container col-sm-11">
                    <Field
                      name="message"
                      id="guest-message-message"
                      placeholder="A friendly reminder! We still need your RSVP…"
                      component={RenderTextareaField}
                      maxChars={5000}
                      validate={[Validations.REQUIRED, Validations.MAX_LENGTH_5000]}
                    />
                  </div>
                </div>
                {/* RECAPTCHA */ }
                <div className="cta-recaptcha-container">
                  <div className="guest-message-recaptcha-container-v2">
                    <div className="g-recaptcha" data-sitekey={sitekey} data-callback={handleSubmit} data-size="invisible" id="guest-message-recaptcha" />
                  </div>
                </div>
                {/* CHECK BOX / SEND TO SELF */ }
                <div className="checkbox-cc-container-v2">
                  <div className="hidden-xs col-sm-8" />
                  <div className="checkbox col-sm-4">
                    <Field
                      id="guest-message-send-to-self"
                      name="send_to_self"
                      component={RenderCheckboxRadioField}
                      type="checkbox"
                      label="Send a copy to me"
                      styleOverride
                    />
                  </div>
                </div>
                {/* SUBMIT */ }
                <div className="submit-button-container">
                  <RenderSubmitButton pristine={false} submitting={submitting} valid={(valid && notExpired)} value="Send Email" className="send-message-submit" disabled={(guestGroupsWithEmail.length === 0)} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

GuestMessageModal.propTypes = {
  guestGroupsWithEmail: PropTypes.arrayOf(PropTypes.shape({})),
  guestGroupsWithoutEmail: PropTypes.arrayOf(PropTypes.shape({})),
  wedding: PropTypes.shape({}),
  handleSubmit: PropTypes.func.isRequired,
  onSubmit2: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  sitekey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const guestGroups = ownProps.guestGroupIds.map(guestGroupId => state.guestList.guests.byId[guestGroupId]);
  const [guestGroupsWithEmail, guestGroupsWithoutEmail] = _.partition(guestGroups, guest => guest.email_address);

  return {
    initialValues: {
      guest_group_ids: guestGroupsWithEmail.map(guestGroup => guestGroup.id),
      send_to_self: false
    },
    guestGroupsWithEmail,
    guestGroupsWithoutEmail,
    wedding: state.wedding.wedding
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit2: sendMessageRequest => dispatch(sendMessage(sendMessageRequest)).then(() => dispatch(hideModal()))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'GuestMessageForm'
})(GuestMessageModal));



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/GuestMessageModal.jsx